import React, {useEffect, useState} from "react";
import {useFormik} from 'formik'
import * as yup from 'yup'
import {Alert, Button, Checkbox, FormControlLabel, FormGroup, TextField} from "@mui/material";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DesktopDatePicker} from '@mui/x-date-pickers/DesktopDatePicker';
// import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import dayjs from 'dayjs';
import {useDispatch} from "react-redux";
import {signUpWithEmail} from "lib/features/authSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";


const validationSchema = yup.object({
  email: yup
    .string()
    .email()
    .max(50, "Email should not be more than 50 characters")
    .required("Please enter your email"),
  password: yup
    .string()
    .min(8, 'Password should be more than 8 characters')
    .max(50, "Password should not be more than 50 characters")
    .required("Please enter a password")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/,
      'Need at lease one lowercase, one uppercase, one number',
    ),
  rePassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf(
      [yup.ref('password'), null],
      "Password doesn't match",
    ),
  // dob: yup
  //   .object()
  //   .required("Please confirm your date of birth")
});


export default function SignupForm({t, onSuccess=()=>{}}) {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false)
  const [dob, setDob] = useState(dayjs())
  const [maxDate, setMaxDate] = useState(dayjs())

  const initDob = () => {
    let today = dayjs()
    let max = dayjs().set('year', today.year() - 18)
    setMaxDate(max)
    setDob(dayjs(max).format('YYYY/MM/DD'))
  }
  useEffect(() => {
    initDob()
  }, [])

  const handleDobChange = (val) => {
    let temp = dayjs(val).format('YYYY/MM/DD')
    console.log('changing dob: ', temp)
    setDob(temp)
  }

  const form = useFormik({
    initialValues: {
      email: '',
      password: '',
      rePassword: '',
      dob: '1990/01/01',
      isBusinessUser: false,
    },
    validationSchema,
    onSubmit: (cred, actions) => {
      console.log('submitting: ', cred)
      cred.dob = dob
      setLoading(true)
      setSuccess(false)
      setError(false)
      dispatch(signUpWithEmail(cred))
        .unwrap()
        .then(() => {
          setLoading(false)
          setSuccess(true)
          actions.resetForm()
          onSuccess()
        })
        .catch((e) => {
          setError(e?.message || 'Unable to sign up, please try again later.')
          setLoading(false)
        })
    }
  })

  return (
    <div>
      {success && <Alert severity={'success'} className={'w-full mb-4'}>
        <span className={'font-semibold'}>{t('home:signUpSuccessTitle')}</span><br/>
        {
          t('home:signUpSuccessContent')
        }
      </Alert>}
      {error && <Alert severity={'error'} className={'w-full mb-4'}>
        {error}
      </Alert>}
      {
        success ?
            null :
            <form onSubmit={form.handleSubmit}>
              <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label={t('home:email')}
                  value={form.values.email}
                  onChange={form.handleChange}
                  error={form.touched.email && Boolean(form.errors.email)}
                  helperText={form.touched.email && form.errors.email}
                  className={'mb-4'}
              />
              <TextField
                  fullWidth
                  id="password"
                  name="password"
                  label={t('home:password')}
                  type="password"
                  value={form.values.password}
                  onChange={form.handleChange}
                  error={form.touched.password && Boolean(form.errors.password)}
                  helperText={form.touched.password && form.errors.password}
                  className={'mb-4'}
              />
              <TextField
                  fullWidth
                  id="rePassword"
                  name="rePassword"
                  label={t('home:confirmPassword')}
                  type="password"
                  value={form.values.rePassword}
                  onChange={form.handleChange}
                  error={form.touched.rePassword && Boolean(form.errors.rePassword)}
                  helperText={form.touched.rePassword && form.errors.rePassword}
                  className={'mb-4'}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                    fullWidth
                    label={t('home:dob')}
                    inputFormat="MM/DD/YYYY"
                    value={dob}
                    onChange={handleDobChange}
                    renderInput={(params) => <TextField {...params} />}
                    className={'mb-4'}
                    maxDate={maxDate}
                />
              </LocalizationProvider>
              <FormGroup
                  className={'mb-4 w-full'}
              >
                <FormControlLabel
                    label={t('home:businessUser')}
                    control={
                      <Checkbox
                          id="isBusinessUser"
                          name="isBusinessUser"
                          checked={form.values.isBusinessUser}
                          onChange={form.handleChange}
                      />
                    }
                />
              </FormGroup>
              <Button
                  color="primary"
                  className={'!bg-[#108085]'}
                  variant="contained" size={'large'}
                  fullWidth
                  disabled={loading}
                  startIcon={loading && <FontAwesomeIcon icon={solid('circle-notch')} className={'animate-spin-fast'}/>}
                  type="submit">
                {t('home:signUp')}
              </Button>
            </form>
      }
    </div>
  )
}
